<div *ngIf="!loading" class="dropup" style="display: inline-block; margin-right:5px;">
    <button type="button" class="btn btn-sm btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        Stammblatt <span class="caret"></span>
    </button>
    <ul *ngIf="entityArt === eArt.HauptEinrichtung" class="dropdown-menu">
        <li><a class="clicker" (click)="onClick_HE_AngUntr()">Stammblatt Angebote/Untereinrichtungen</a></li>
        <!--<li><a class="clicker" (click)="onClick_HE_PersBlatt()">Personaldatenblatt Haupteinrichtung</a></li>
        <li><a class="clicker" (click)="onClick_HE_BesVork()">Besondere Vorkommnisse</a></li>-->
    </ul>
    <ul *ngIf="entityArt === eArt.UnterEinrichtung" class="dropdown-menu">
        <!-- <li><a class="clicker" (click)="onClick_HE_AngUntr()">Stammblatt Angebote/Untereinrichtungen</a></li> -->
        <li><a class="clicker" (click)="onClick_UE_PersonalUebersicht()">Personalübersicht</a></li>
        <!--   <li><a class="clicker" (click)="onClick_HE_BesVork()">Besondere Vorkommnisse</a></li>-->
    </ul>
</div>

<dx-popup title="Untereinrichtungen auswählen!" [width]="'50%'" [height]="'150'" [(visible)]="isPopupVisible"
    style="display: inline-block;" (onHidden)="onHiddenPopup($event)">
    <div *dxTemplate="let data of 'content'">

        <dx-scroll-view #scrollView id="scrollview" [scrollByContent]="true" [scrollByThumb]="true" height="100%"
            [showScrollbar]="'onHover'" [bounceEnabled]="false" reachBottomText="Updating...">

            <dx-form #form [(formData)]="spezialContext">
                <dxi-item [label]="{text: 'Untereinrichtungen'}" dataField="ues" editorType="dxTagBox"
                    [editorOptions]="{ items: ues, maxDisplayedTags: 3, displayExpr: getDisplayValue,  valueExpr: 'id', searchEnabled: true, searchExpr: 'name' }">
                    <dxi-validation-rule type="required" message="Untereinrichtung wird benötigt!">
                    </dxi-validation-rule>
                </dxi-item>
            </dx-form>

        </dx-scroll-view>

    </div>

    <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
        disabled: canCreate,
        text: 'Erstellen',
        onClick: onClickErstellen
    }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
        text: 'Abbrechen',
        onClick: onClickClose
    }">
    </dxi-popup-toolbar-item>
</dx-popup>
